import { MonthRangePicker } from '@/components/MonthRangePicker'
import { Button } from '@/components/ui/button'
import { DateRangePicker } from '@/components/ui/DateRangePicker'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Granularity } from '@/models/emailReport'

interface Props {
  granularity: Granularity
  start: string
  end: string
  sender: string
  senders: string[]
  onGranularity: (g: Granularity) => void
  onStart: (v: string) => void
  onEnd: (v: string) => void
  onSender: (v: string) => void
}

const ALL_SENDERS = '__all__'

export function ReportingControls(props: Props) {
  const isMonth = props.granularity === Granularity.MONTH

  const onRange = (start: string, end: string) => {
    props.onStart(start)
    props.onEnd(end)
  }

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end sm:gap-4">
      <div className="flex gap-2">
        <Button
          variant={props.granularity === Granularity.DAY ? 'default' : 'outline'}
          onClick={() => props.onGranularity(Granularity.DAY)}
        >
          Day
        </Button>
        <Button
          variant={isMonth ? 'default' : 'outline'}
          onClick={() => props.onGranularity(Granularity.MONTH)}
        >
          Month
        </Button>
      </div>
      <div className="flex flex-col gap-1 text-sm">
        <span>{isMonth ? 'Months' : 'Date range'}</span>
        {isMonth ? (
          <MonthRangePicker start={props.start} end={props.end} onChange={onRange} />
        ) : (
          <DateRangePicker start={props.start} end={props.end} onChange={onRange} />
        )}
      </div>
      <div className="w-full sm:w-56">
        <Select
          value={props.sender || ALL_SENDERS}
          onValueChange={(v) => props.onSender(v === ALL_SENDERS ? '' : v)}
        >
          <SelectTrigger>
            <SelectValue placeholder="All senders" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL_SENDERS}>All senders</SelectItem>
            {props.senders.map((s) => (
              <SelectItem key={s} value={s}>
                {s}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
